import $ from "jquery";
import * as localAPI from "localAPI";

let startedFetchingGoogleScript = false;
let loaded = false;
/** @type {((google: object) => void)[]} */
let loadedCallbacks = [];

const doWhenLoaded = (callback) => {
  if (!startedFetchingGoogleScript) {
    $.getScript("https://accounts.google.com/gsi/client", () => {
      loaded = true;
      // @ts-ignore
      const google = window.google;

      google.accounts.id.initialize({
        client_id:
          // cspell: disable-next-line
          "600294213540-bfp4atl7c31mg86um6dcq2lvb635umom.apps.googleusercontent.com",
        callback: (response) => {
          // First make call to complete login to Readlang backend
          $.post("/api/auth/googleSignIn", {
            idToken: response.credential,
          }).done(
            // XXX Can't pass an async function here directly or it doesn't get called
            () =>
              (async () => {
                // Redirect or refresh
                await localAPI.setLocalMode(false);
                redirectOrReload();
              })()
          );
        },
      });

      for (const loadedCallback of loadedCallbacks) {
        // @ts-ignore
        loadedCallback(google);
      }
      loadedCallbacks = [];
    });
    startedFetchingGoogleScript = true;
  }

  if (loaded) {
    // @ts-ignore
    callback(window.google);
  } else {
    loadedCallbacks.push(callback);
  }
};

var redirectOrReload = () => {
  if (
    window.location.pathname === "/" ||
    window.location.pathname === "/login"
  ) {
    window.location.pathname = "/startSignedIn";
  } else {
    window.location.reload();
  }
};

export const signOut = () => {
  doWhenLoaded((google) => {
    google.signOut();
  });
};

export const attachSignInClickHandler = (container) => {
  if (detachedSignInContainer) {
    // Re-use previous button. If we don't do this and call google.accounts.id.renderButton() again,
    // the button ends up being the wrong width.
    container.parentNode.replaceChild(detachedSignInContainer, container);
    return;
  }

  doWhenLoaded((google) => {
    google.accounts.id.renderButton(container, {
      theme: "filled_blue",
      size: "large",
      width: `${Math.floor($(container).width())}`,
      locale: "en",
    });
  });
};

let detachedSignInContainer = undefined;

/**
 * Keeps a reference to the sign in button so we can re-use it instead of creating a new one.
 * Creating a new one is bad since it results in the button being the wrong width.
 *
 * @param {HTMLElement} container
 */
export const detachSignInClickHandler = (container) => {
  detachedSignInContainer = container;
  container?.parentNode?.removeChild(container);
};
